import { create } from 'zustand';

export type Language = 'ko' | 'en';

interface LanguageState {
  locale: Language;
  setLocale: (locale: Language) => void;
}

export const useLanguageStore = create<LanguageState>((set) => ({
  locale: (localStorage.getItem('onkiz_lang') as Language) || 'ko',
  setLocale: (locale) => set({ locale }),
}));
